module.exports = __webpack_public_path__ + "img/treehouse-stats.5c28ab05.png";